import React, { useState, useEffect, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import apiService from '../../services/apiService';
import { toast } from 'react-toastify';

const WebPrivacy = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    privacy: '',
    term_and_condition: ''
  });

  const editorConfig = useMemo(() => ({
    readonly: false,
    height: 400,
    uploader: {
      insertImageAsBase64URI: false
    },
    buttons: [
      'bold', 'italic', 'underline', 'strikethrough', '|',
      'font', 'fontsize', '|',
      'brush', '|',
      'align', '|',
      'ul', 'ol', '|',
      'table', '|',
      'undo', 'redo'
    ],
    disablePlugins: 'video,file,audio,speech-recognize,image',
  }), []);

  useEffect(() => {
    fetchPrivacyData();
  }, []);

  const fetchPrivacyData = async () => {
    setLoading(true);
    try {
      const response = await apiService.get('privacy');
      if (response.data) {
        setFormData({
          id: response.data._id || '',
          privacy: response.data.privacy || '',
          term_and_condition: response.data.term_and_condition || ''
        });
      }
    } catch (error) {
      toast.error('Failed to fetch privacy data');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await apiService.post('updatePrivacy', formData);
      if (response.success) {
        toast.error(response.message);
      } else {
        toast.success('Updated successfully');
      }
    } catch (error) {
      toast.error('Something went wrong, try again!!');
    } finally {
      setLoading(false);
    }
  };

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'color': [] }, { 'background': [] }],
      ['clean']
    ]
  };

  return (
    <div className="flex-1 overflow-auto bg-gray-50">
      <div className="p-0">
        <div className="bg-white rounded-lg shadow">
          <form onSubmit={handleSubmit}>
            <div className="p-6 space-y-6">
              {/* Privacy Policy */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Privacy Policy
                </label>
                <JoditEditor
                  value={formData.privacy}
                  config={editorConfig}
                  onBlur={newContent => setFormData({ ...formData, privacy: newContent })}
                />
              </div>

              {/* Terms & Conditions */}
              <div className="mt-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Term & Condition
                </label>
                <JoditEditor
                  value={formData.term_and_condition}
                  config={editorConfig}
                  onBlur={newContent => setFormData({ ...formData, term_and_condition: newContent })}
                />
              </div>

              {/* Submit Button */}
              <div className="flex justify-start mt-6">
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-2 text-sm font-medium text-white rounded-lg transition-colors"
                  style={{ backgroundColor: '#50cd89' }}
                  onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = '#47b881')}
                  onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = '#50cd89')}
                >
                  {loading ? 'Please wait...' : 'Update'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WebPrivacy;
